import { useEffect, useState } from 'react';
import { ThemeService } from '../services/ThemeService';

export const useResolvedTheme = () => {
    const [resolvedTheme, setResolvedTheme] = useState(
        ThemeService.getResolvedTheme(),
    );

    useEffect(() => {
        const handleThemeChange = () => {
            setResolvedTheme(ThemeService.getResolvedTheme());
        };

        window.addEventListener('theme-change', handleThemeChange);

        return () => {
            window.removeEventListener('theme-change', handleThemeChange);
        };
    }, []);

    return resolvedTheme;
};